import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import Print from 'vue-print-nb'
import '@/assets/reset.css'
import './plugins/element'
import moment from 'moment'
import { MessageBox } from 'element-ui'
import VueDirectiveImagePreviewer from 'vue-directive-image-previewer'
import 'vue-directive-image-previewer/dist/assets/style.css'

Vue.use(VueDirectiveImagePreviewer)

if (process.env.NODE_ENV === 'production') {
  // axios.defaults.baseURL = 'http://119.1.144.99:4719'
  axios.defaults.baseURL = serverConfig.ApiUrl
}else {
  axios.defaults.baseURL = process.env.VUE_APP_URL
}


axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'
axios.defaults.headers.get['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// 需要授权的 API ，必须在请求头中使用 `auth` 字段提供 `token` 令牌
axios.interceptors.request.use(config => {
  // console.log(axios.defaults.baseURL)
  config.headers.Authorization = window.sessionStorage.getItem('token')
  return config
})

axios.interceptors.response.use(response => {
  if (response.data.ResponseCode == 401) {
    MessageBox.alert('登录过期，请重新登录', '提示', {
      confirmButtonText: '确定',
      callback: action => {
        // this.$message({
        //   type: 'info',
        //   message: '请重新登录'
        // })
        window.sessionStorage.clear()
        router.push('/')
      }
    })
  }
  return response
})

Vue.prototype.$axios = axios
Vue.prototype.formData = qs.stringify
Vue.prototype.$moment = moment

Vue.config.productionTip = false

Vue.use(Print)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
